import React, { useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { SFAppBar, SFUseStyled, SFContentContainer } from "@sf-core";
import { Logger } from "@base-provider";
import { SFLogo } from "../../assets";
import CloseIcon from "@mui/icons-material/Close";
import "./index.scss";
import { useSelector } from "react-redux";

const { styled } = SFUseStyled();

const StyledContainer = styled(SFContentContainer)(({ isgo1 }) => ({
  position: "relative",
  zIndex: "9999999",
  backgroundColor: "#000000",
  ...(isgo1 && {
    "& .course-player-viewer-head": {
      display: "none !important",
    },
  }),
  ...(!isgo1 && {
    "& .course-player-viewer-head": {
      justifyContent: "flex-end",
      "& .course-player-viewer-head-navigation-back, & .course-player-viewer-head-content":
        {
          display: "none !important",
        },
    },
  }),
}));

// if (go1) -> hide flow player frame -> else -> hide title

const VideoPlayer = ({ course, onClose = () => {}, loadIdFromUrl = false }) => {
  const isPlayerLoaded = useSelector(
    (state) => state.launchPadLayout.isPlayerLoaded
  );

  let { id } = useParams();
  id = id.toLowerCase();
  
  let params = {};
  if (loadIdFromUrl) {
    Logger.of("App.VideoPlayer.loadIdFromUrl").info({ id });
    let search = useLocation().search;
    Logger.of("App.VideoPlayer.loadIdFromUrlSearch").info({ id, search });
    // convert search params to an object
    params = Object.fromEntries(new URLSearchParams(search));
    Logger.of("App.VideoPlayer.loadIdFromUrlParams").info({
      id,
      search,
      params,
    });

    course = {
      title: "Custom loaded from URL",
      externalRemoteId: id,
    };
  }

  function handleMessage(event) {
    Logger.of("App.VideoPlayer.doceboEvent").info({ event });
    if (event?.data?.target === "dcd" && event?.data?.status === "completed") {
      onClose && onClose();
    }
  }

  useEffect(() => {
     
    window.addEventListener("message", handleMessage);

    // cleanup this component
    return () => {
       
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  Logger.of("App.VideoPlayer.Init").info({
    isPlayerLoaded,
    course,
  });

  if (!isPlayerLoaded) return null;

  return (
    <>
      <StyledContainer disableGutters isgo1={course.isGo1}>
        <SFAppBar
          logo={<SFLogo />}
          disableGradient
          items={[
            {
              //icon: HomeIconAnimation.View,
              title: course?.title,
            },
          ]}
          itemsRight={[
            {
              icon: <CloseIcon />,
              title: "Save & Exit",
              onClick: () => {
                onClose();
              },
            },
          ]}
        />
        <dcbo-course-player
          autoplay={true}
          showpreview={false}
          id="player"
          courseid={course.externalRemoteId}
        />
      </StyledContainer>
    </>
  );
};
/*
  autoplay="false"
  showpreview="false"
  forcefullscreen="false"
  showfullscreen="false"
  showpip="false"
  showtoc="false"
  showthumbsintoc="false"
*/
export default VideoPlayer;
